export default __webpack_public_path__ + "static/form-grouping-do-96044e13f1a56d6598876730f6d7250b.png";